

export class Feed  {
    constructor(
        public id?: number,
        public name?: string,
        public location?: string,
    public index?: number
) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed.model.ts